// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  /* padding-top: 10rem; */
}
footer .content {
  background-color: #cbe3d9;
  padding-top: 4rem;
  min-height: 50vh;
  padding-left: 5rem;
  padding-right: 5rem;
  padding-bottom: 2rem;
  width: 100%;
}
footer .content-top {
  display: flex;
  justify-content: space-around;
}
footer .content-top h2 {
  color: #327a6d;
  padding-bottom: 3rem;
}
footer .content-top .nav {
  display: flex;
  flex-direction: column;
  align-items: center;
}
footer .content-top .nav a {
  text-decoration: none;
  color: #000;
  font-size: 1rem;
  padding-bottom: 2rem;
  width: fit-content;
}
footer .content-top .nav a:hover {
  text-decoration: underline;
  height: fit-content;
  color: #327a6d;
}

footer aside {
  color: #327a6d;
}
footer aside div p {
  font-size: 0.9rem;
  color: #000;
}

footer aside div img {
  background-color: #fff;
  width: 130px;
  margin-bottom: 1.4rem;
}

footer aside div i {
  color: #000;
  font-size: 14px;
}

footer aside div .bi-geo-alt-fill {
  margin-top: 2px;
}

footer .content hr {
  color: #000;
}
footer .content .content-bottom {
  text-align: end;
}
footer .content .content-bottom .tag {
  text-decoration: none;
  color: #000;
  font-size: 0.9rem;
}
footer .content .content-bottom .tag:hover {
  color: #327a6d;
  transition: 0.3s;
}

@media (min-width: 600px) and (max-width: 1080px) {
  footer .content .content-bottom .tag {
    font-size: 0.8rem;
  }
  footer .content .content-top {
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

@media (max-width: 580px) {
  footer .content .content-top {
    flex-wrap: wrap;
    gap: 4rem;
  }

  aside h2 {
    text-align: center;
  }

  aside div .inner-aside {
    justify-content: center;
    align-items: center;
  }
  footer .content .content-bottom .tag {
    font-size: 0.7rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/footer.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["footer {\r\n  /* padding-top: 10rem; */\r\n}\r\nfooter .content {\r\n  background-color: #cbe3d9;\r\n  padding-top: 4rem;\r\n  min-height: 50vh;\r\n  padding-left: 5rem;\r\n  padding-right: 5rem;\r\n  padding-bottom: 2rem;\r\n  width: 100%;\r\n}\r\nfooter .content-top {\r\n  display: flex;\r\n  justify-content: space-around;\r\n}\r\nfooter .content-top h2 {\r\n  color: #327a6d;\r\n  padding-bottom: 3rem;\r\n}\r\nfooter .content-top .nav {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\nfooter .content-top .nav a {\r\n  text-decoration: none;\r\n  color: #000;\r\n  font-size: 1rem;\r\n  padding-bottom: 2rem;\r\n  width: fit-content;\r\n}\r\nfooter .content-top .nav a:hover {\r\n  text-decoration: underline;\r\n  height: fit-content;\r\n  color: #327a6d;\r\n}\r\n\r\nfooter aside {\r\n  color: #327a6d;\r\n}\r\nfooter aside div p {\r\n  font-size: 0.9rem;\r\n  color: #000;\r\n}\r\n\r\nfooter aside div img {\r\n  background-color: #fff;\r\n  width: 130px;\r\n  margin-bottom: 1.4rem;\r\n}\r\n\r\nfooter aside div i {\r\n  color: #000;\r\n  font-size: 14px;\r\n}\r\n\r\nfooter aside div .bi-geo-alt-fill {\r\n  margin-top: 2px;\r\n}\r\n\r\nfooter .content hr {\r\n  color: #000;\r\n}\r\nfooter .content .content-bottom {\r\n  text-align: end;\r\n}\r\nfooter .content .content-bottom .tag {\r\n  text-decoration: none;\r\n  color: #000;\r\n  font-size: 0.9rem;\r\n}\r\nfooter .content .content-bottom .tag:hover {\r\n  color: #327a6d;\r\n  transition: 0.3s;\r\n}\r\n\r\n@media (min-width: 600px) and (max-width: 1080px) {\r\n  footer .content .content-bottom .tag {\r\n    font-size: 0.8rem;\r\n  }\r\n  footer .content .content-top {\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n  }\r\n}\r\n\r\n@media (max-width: 580px) {\r\n  footer .content .content-top {\r\n    flex-wrap: wrap;\r\n    gap: 4rem;\r\n  }\r\n\r\n  aside h2 {\r\n    text-align: center;\r\n  }\r\n\r\n  aside div .inner-aside {\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  footer .content .content-bottom .tag {\r\n    font-size: 0.7rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
